<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
  >
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      :label-col="{ style: { width: '120px' } }"
      layout="inline"
      :wrapper-col="{ style: { width: '240px' } }"
    >
      <a-form-item label="成品" name="fqcId">
        <a-select
          v-if="formState.fqcId === null || modalConfig.type === 'insert'"
          v-model:value="formState.fqcId"
          @change="handleSelectFQC"
          :options="FQCOptions"
          placeholder="请选择成品"
          show-search
          :filterOption="(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }"
        >
        </a-select>

        <a-input
          :value="`${formState.modelSpecifications}/${formState.serial}`"
          :disabled="!warehouseEditAuthority"
          v-else
        >
          <template #suffix v-if="warehouseEditAuthority">
            <CloseCircleOutlined @click="handleResetFqc" />
          </template>
        </a-input>
      </a-form-item>

      <a-form-item label="总装调试SN号" name="assembleDebugsnNumber">
        <a-input
          v-model:value="formState.assembleDebugsnNumber"
          placeholder="总装调试SN号"
          allowClear
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="生产批号" name="batchNumber">
        <a-input
          v-model:value="formState.batchNumber"
          placeholder="生产批号"
          allowClear
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="型号" name="modelSpecifications">
        <a-input
          v-model:value="formState.modelSpecifications"
          placeholder="型号"
          allowClear
          disabled
        ></a-input>
      </a-form-item>
      <a-form-item label="机身号" name="serial">
        <a-input
          v-model:value="formState.serial"
          placeholder="机身号"
          allowClear
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="生产日期" name="localDate">
        <a-date-picker
          @change="handleSelectDate($event, 'localDate')"
          v-model:value="formState.localDate"
          placeholder="生产日期"
          disabled
        >
        </a-date-picker>
      </a-form-item>

      <a-form-item label="对接人" name="contactPerson">
        <a-input v-model:value="formState.contactPerson" placeholder="对接人" allowClear></a-input>
      </a-form-item>
      <a-form-item label="客户信息" name="customerInfo">
        <a-textarea
          v-model:value="formState.customerInfo"
          placeholder="客户信息"
          allowClear
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="物流信息" name="logisticsInfo">
        <a-textarea
          v-model:value="formState.logisticsInfo"
          placeholder="物流信息"
          allowClear
          auto-size
        ></a-textarea>
      </a-form-item>
      <a-form-item label="收货地址" name="address">
        <a-textarea
          v-model:value="formState.address"
          placeholder="收货地址"
          allowClear
          auto-size
        ></a-textarea>
      </a-form-item>

      <a-form-item label="发货日期" name="shippedDate">
        <a-date-picker
          v-model:value="formState.shippedDate"
          placeholder="发货日期"
          allowClear
          @change="handleSelectDate($event, 'shippedDate')"
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="用途" name="purpose">
        <a-select
          v-model:value="formState.purpose"
          :options="purposeOption"
          placeholder="请选择用途"
          allowClear
        >
        </a-select>

        <!-- <a-textarea
          v-model:value="formState.purpose"
          placeholder="用途"
          auto-size
          allowClear
        ></a-textarea> -->
      </a-form-item>
      <!-- 
      <a-form-item label="备注" name="notes">
        <a-textarea
          v-model:value="formState.notes"
          placeholder="备注"
          auto-size
          allowClear
        ></a-textarea>
      </a-form-item> -->

      <a-form-item label="附件" name="annex">
        <!-- <a-input
          v-model:value="formState.annex"
          placeholder="附件"
          allowClear
        ></a-input> -->
        <upload @setUploadFileUrl="setUploadFileUrl" ref="fileRef"></upload>
      </a-form-item>

      <!-- <div style="width: 600px; padding-left: 20px; margin-bottom: 10px">
        <h1>配件</h1>
      </div>

      <swan-accessory
        :accessory="formState.swanAccessory"
        ref="swanAccessoryRef"
      ></swan-accessory> -->
    </a-form>
  </a-modal>
</template>
<script>
import { defineComponent, reactive, ref, inject, nextTick } from "vue";
import { CloseCircleOutlined } from "@ant-design/icons-vue";
import { Toast } from "@/utils";
import {
  insertOQC,
  getFQCQualifiedList,
  updateOQC,
  getSwanAccessory,
  saveSwanAccessory,
} from "@/request/view/warehouse";
import { uploadInspectionAttachment } from "@/request/view/dailyQualityInspection";
import { updateSwanAccessory } from "@/request/view/repair";
import { purposeOption } from "@/views/productDaily/warehouse/option";
import { showModal as showCheckModal } from "@/views/repairprogress/serve/modal";
import swanAccessory from "@/views/productDaily/warehouse/updateSwanAccessory.vue";
import upload from "@/views/rdmanagement/components/database/multipleUpload.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    CloseCircleOutlined,
    swanAccessory,
    upload,
  },
  setup(props, context) {
    const swanAccessoryRef = ref();
    const warehouseEditAuthority = inject("warehouseEditAuthority", false);
    const fileRef = ref();
    const formRef = ref();
    const route = useRoute();

    const formState = reactive({
      address: null,
      annex: null,
      assembleDebugsnNumber: null,
      batchNumber: null,
      contactPerson: null,
      customerInfo: null,
      inspectionFrequency: null,
      inspectionIssues: null,
      logisticsInfo: null,
      fqcId: null,
      id: null,
      modelSpecifications: null,
      notes: null,
      produceOrTpc: route.meta.produceOrTpc,
      purpose: null,
      serial: null,
      shippedDate: null,
      status: null,
      swanAccessory: null,
      userId: null,
      username: null,
    });

    // 回显文件
    const setEchoFile = () => {
      nextTick(() => {
        fileRef.value.setEchoFile(formState.annex);
      });
    };

    // 上传文件
    const setUploadFileUrl = (fileList) => {
      const annexList = [];
      fileList.value.forEach((file) => {
        annexList.push(file.url);
      });
      formState.annex = annexList.toString();
    };

    const FQCOptions = ref([]);

    const rules = {
      fqcId: [
        {
          required: true,
          message: "请选择成品",
          type: "number",
          trigger: "change",
        },
      ],
      address: [
        {
          required: true,
          message: "请输入收获地址",
          type: "string",
          trigger: "change",
        },
      ],
      contactPerson: [
        {
          required: true,
          message: "请输入收获地址",
          type: "string",
          trigger: "change",
        },
      ],

      customerInfo: [
        {
          required: true,
          message: "请输入客户信息",
          type: "string",
          trigger: "change",
        },
      ],
      logisticsInfo: [
        {
          required: true,
          message: "请输入收货地址",
          type: "string",
          trigger: "change",
        },
      ],
      shippedDate: [
        {
          required: true,
          message: "请选择发货日期",
          type: "string",
          trigger: "change",
        },
      ],
    };
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const getFQCOption = () => {
      getFQCQualifiedList({
        produceOrTpc: route.meta.produceOrTpc,
      }).then((res) => {
        FQCOptions.value.length = 0;
        res.data.forEach((item) => {
          if (item.isUsed) return;
          const assignItem = Object.assign(item, {
            label: `${item.modelSpecifications}/${item.serial}`,
            value: item.id,
          });
          FQCOptions.value.push(assignItem);
        });
      });
    };
    // 获取天鹅配件
    const getAccessory = () => {
      getSwanAccessory({
        oqcId: formState.id,
      }).then((res) => {
        formState.swanAccessory = res.data;
      });
    };
    // 更新天鹅配件
    const updateAccessory = (accessory) => {
      if (!accessory.oqcId) accessory.oqcId = formState.id;
      saveSwanAccessory(accessory);
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formState.produceOrTpc = route.meta.produceOrTpc;
      console.log(formState, "form state ");
      formRef.value.clearValidate();
    };

    const showModal = (type, options) => {
      const { title, data } = options;
      getFQCOption();
      modalConfig.title = title;
      modalConfig.visible = true;
      modalConfig.type = type;
      nextTick(() => {
        if (type === "update") {
          Object.keys(formState).forEach((key) => {
            formState[key] = data[key];
          });
          // getAccessory();
        }
        setEchoFile();
      });
      console.log(formState, "form state");
    };

    const handleCancel = () => {
      resetForm();
      fileRef.value.resetFileList();
      modalConfig.title = null;
      modalConfig.visible = false;
      modalConfig.type = null;
    };

    let trigger = false;

    const handleOk = () => {
      // 获取配件信息
      // const accessory = swanAccessoryRef.value.getSwanAccessory();
      // formState.swanAccessory = accessory;

      // 选择的配件个数
      // const accessoryCount = Object.keys(accessory)
      //   .filter((f) => f !== "id" && f !== "oqcId")
      //   .reduce((pre, key) => {
      //     return pre + Number(accessory[key]);
      //   }, 0);

      // if (accessoryCount === 0) return Toast("warning", "请选择配件", 3);

      // 更新天鹅配件
      // if (modalConfig.type === "update") {
      //   updateAccessory(accessory);
      // }

      if (trigger) return;
      formRef.value
        .validateFields()
        .then((res) => {
          const reqFn = modalConfig.type === "insert" ? insertOQC : updateOQC;
          trigger = true;
          reqFn(formState)
            .then((res) => {
              trigger = false;
              const type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              handleCancel();
              context.emit("handleUpdateTable");
            })
            .catch((err) => {
              trigger = false;
            });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    const handleSelectFQC = (e, option) => {
      const fqc = FQCOptions.value.find((f) => f.value == e);
      const setDataKeylist = [
        "assembleDebugsnNumber",
        "batchNumber",
        "modelSpecifications",
        "serial",
        "serialNumber",
        "localDate",
      ];

      if (fqc) {
        setDataKeylist.forEach((key) => {
          formState[key] = fqc[key];
        });
        return;
      }

      setDataKeylist.forEach((key) => {
        formState[key] = null;
      });
    };

    const handleSelectDate = (e, key) => {
      if (!e) formState[key] = null;
      formState[key] = e.format("YYYY-MM-DD");
    };

    const handleResetFqc = () => {
      showCheckModal({
        title: "提示",
        toastText: "取消选择的成品？",
        success: () => {
          formState.fqcId = null;
          handleSelectFQC(null);
        },
      });
    };

    return {
      formRef,
      formState,
      swanAccessoryRef,
      rules,
      showModal,
      handleResetFqc,
      handleCancel,
      handleOk,
      modalConfig,
      FQCOptions,
      warehouseEditAuthority,
      handleSelectFQC,
      fileRef,
      setUploadFileUrl,
      purposeOption,
      uploadInspectionAttachment,
      handleSelectDate,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-row) {
  margin-bottom: 8px;
}
</style>
